<template>
    <v-card flat>
        <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row class="no-gutters pb-5">
                <v-col cols="12" sm="12" md="6" lg="6">
                    <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here..." single-line solo
                        hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="2">
                    <v-select solo :items="allAccounts()" v-model="account" @input="accountFilter"
                        append-icon="mdi-chevron-down" label="Account Types" class="custom-select"
                        item-text="account_type_display" item-value="id"></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="4">
                    <ul>
                        <li>
                            <span>Total Equity:</span>
                            <span>{{ formattedAllNumber(totalEquity) }}</span>
                        </li>
                        <li>
                            <span>Total Lot:</span>
                            <span>{{ formattedAllNumber(totalVolume) }}</span>
                        </li>
                        <li>
                            <span class="profit-loss">Profit / Loss:</span>
                            <span>{{ formattedAllNumber(totalProfit) }}</span>
                        </li>
                    </ul>
                </v-col>
            </v-row>
        </v-card>
        <v-row>
            <v-col cols="12" sm="12">
                <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                    <v-sheet class="transactionTable depositTableForTransaction"
                        :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                        <v-data-table :headers="headers" :items="trades" :search="search" :items-per-page="5">
                            <template v-slot:item.Price="{ item }">
                                {{ item?.Price?.toFixed(2) }}
                            </template>
                            <template v-slot:item.PricePosition="{ item }">
                                {{ item?.PricePosition?.toFixed(2) }}
                            </template>
                            <template v-slot:item.Volume="{ item }">
                                {{ item?.Volume / 10000 }}
                            </template>
                            <template v-slot:item.Time="{ item }">
                                {{ formatMySQLDate(item?.Time) }}
                            </template>
                            <template v-slot:item.Login="{ item }">
                                {{ item?.Login + "(" + item.account_type_display + ")" }}
                            </template>
                            <template v-slot:item.Action="{ item }">
                                <span :class="getColor(item.Action)">
                                    {{
                                        item?.Action === 0
                                            ? "Buy"
                                            : item?.Action === 1
                                                ? "Sell"
                                                : null
                                    }}
                                </span>
                            </template>
                        </v-data-table>
                    </v-sheet>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { formatNumber } from "@/_helpers/formatNumber";
import { formatMySQLDate } from "@/_helpers/formateDate";
import {
    ACCOUNTTYPES__ACTIONS,
    USERCLOSEDTRADES__ACTIONS
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    data() {
        return {
            search: "",
            account: null,
            headers: [
                { text: "Account", align: "start", value: "Login" },
                { text: "Ticket", value: "PositionID" },
                { text: "Time", value: "Time" },
                { text: "Lots", value: "Volume" },
                { text: "Symbol", value: "Symbol" },
                { text: "Open Price", value: "Price" },
                { text: "Closed Price", value: "PricePosition" },
                { text: "Profit", value: "Profit" },
                { text: "Type", value: "Action" },
            ],
            modal: false,
            options: {
                chart: {
                    id: "vuechart-example",
                    type: "bar",
                    height: "338px",
                    theme: "dark",
                },

                xaxis: {
                    labels: {
                        style: {
                            colors: [
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                                "#708AA7",
                            ],
                        },
                    },
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: ["#708AA7"],
                        },
                    },
                },
                plotOptions: {
                    bar: {
                        columnWidth: "40%",
                    },
                },
                colors: ["#039de9"],
                dataLabels: {
                    enabled: false,
                },
                grid: {
                    show: false,
                },
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    show: true,
                    showForSingleSeries: true,
                    customLegendItems: ["Profit", "Loss"],
                    labels: {
                        colors: ["#647E98"],
                        useSeriesColors: false,
                    },
                    markers: {
                        fillColors: ["#039de9", "#647E98"],
                        radius: 12,
                    },
                },
            },
            series: [
                {
                    name: "Actual",
                    data: [
                        {
                            x: "01/01",
                            y: 4000,
                        },
                        {
                            x: "02/01",
                            y: 3000,
                        },
                        {
                            x: "03/01",
                            y: 2000,
                        },
                        {
                            x: "04/01",
                            y: 1000,
                        },
                        {
                            x: "05/01",
                            y: 3500,
                        },
                        {
                            x: "06/01",
                            y: 1500,
                        },
                        {
                            x: "07/01",
                            y: 2000,
                        },
                        {
                            x: "08/01",
                            y: 4000,
                        },
                        {
                            x: "09/01",
                            y: 2500,
                        },
                        {
                            x: "10/01",
                            y: 2300,
                        },
                        {
                            x: "11/01",
                            y: 1000,
                        },
                        {
                            x: "12/01",
                            y: 500,
                        },
                        {
                            x: "13/01",
                            y: 4000,
                        },
                        {
                            x: "14/01",
                            y: 3800,
                        },
                        {
                            x: "15/01",
                            y: 1200,
                        },
                        {
                            x: "16/01",
                            y: 700,
                        },
                        {
                            x: "17/01",
                            y: 1300,
                        },
                        {
                            x: "18/01",
                            y: 3000,
                        },
                        {
                            x: "19/01",
                            y: 1700,
                        },
                        {
                            x: "20/01",
                            y: 2100,
                        },
                        {
                            x: "21/01",
                            y: 1000,
                        },
                        {
                            x: "22/01",
                            y: 1900,
                        },
                    ],
                },
            ],
            selectedDates: [],
            selectedDatesText: null,
            clientId: null,
            refreshInterval: null,
            isTabVisible: true,
        };
    },

    computed: {
        ...mapState("accounttypes", ["accounttypes"]),
        ...mapState("userclosedtrades", [
            "trades",
            "totalProfit",
            "totalVolume",
            "totalEquity",
            "isLoading",
        ]),
    },

    methods: {
        formatMySQLDate,
        ...mapActions("userclosedtrades", [USERCLOSEDTRADES__ACTIONS.USERCLOSEDTRADES]),
        ...mapActions("accounttypes", [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]),

        getColor(action) {
            if (action === 0) return "text--green";
            else return "text-red";
        },

        formattedAllNumber(num) {
            return formatNumber(num || 0);
        },

        allAccounts() {
            return [{ id: "All", account_type_display: "All" }, ...this.accounttypes];
        },

        accountFilter() {
            let parameter = {
                clientId: this.clientId,
                trading_account_type_id: this.account === "All" ? null : this.account,
            };

            this[USERCLOSEDTRADES__ACTIONS.USERCLOSEDTRADES](parameter);
        },

        startAutoRefresh() {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }

            this.refreshInterval = setInterval(() => {
                if (this.isTabVisible) {
                    this.$store.dispatch('userclosedtrades/fetchUpdates');
                }
            }, 3000);
        },

        handleVisibilityChange() {
            if (document.hidden) {
                this.isTabVisible = false;
            } else {
                this.isTabVisible = true;
                this.$store.dispatch('userclosedtrades/fetchUpdates');
            }
        },

        stopAutoRefresh() {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        }
    },

    async mounted() {
        this.clientId = this.$route.params.id
        await this[ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]();
        await this[USERCLOSEDTRADES__ACTIONS.USERCLOSEDTRADES]({ clientId: this.$route.params.id });
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.startAutoRefresh();
    },

    beforeDestroy() {
        this.stopAutoRefresh();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
};
</script>
